// bootstrap was substituted with material-kit.js
// import 'bootstrap';
/* Popper and jQuery are required in global scope for metrial-kit to work */
/* it is bad practice to do it like global.*, but whatever works */
import $ from 'jquery';
global.$ = $;
global.jQuery = $;
import Popper from 'popper.js';
global.Popper = Popper;
import "slick-carousel";
// material-design is missing component 'Toast'
// It would be better to do `import Toast from 'bootstrap'. But then material-design interfers with the native bootstrap.
// So the missing component 'Toast' is imported directly from source
import Toast from 'bootstrap/js/src/toast';

require('material-kit/assets/js/core/bootstrap-material-design.min.js');
require('material-kit/assets/js/material-kit.js');